import { cn as e } from "../../lib/utils.es.js";
import { getEmbedPortalContainer as t } from "../../lib/embed-portal-container.es.js";
import "react";
import { XIcon as n } from "lucide-react";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import * as a from "@radix-ui/react-dialog";
// libs/ui-lib/src/components/ui/dialog.tsx
function o({ ...e }) {
	return /* @__PURE__ */ r(a.Root, {
		"data-slot": "dialog",
		...e
	});
}
function s({ ...e }) {
	return /* @__PURE__ */ r(a.Trigger, {
		"data-slot": "dialog-trigger",
		...e
	});
}
function c({ container: e, ...n }) {
	return /* @__PURE__ */ r(a.Portal, {
		"data-slot": "dialog-portal",
		container: e ?? t() ?? void 0,
		...n
	});
}
function l({ ...e }) {
	return /* @__PURE__ */ r(a.Close, {
		"data-slot": "dialog-close",
		...e
	});
}
function u({ className: t, ...n }) {
	return /* @__PURE__ */ r(a.Overlay, {
		"data-slot": "dialog-overlay",
		className: e("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50", t),
		...n
	});
}
function d({ className: t, overlayClassName: o, container: s, children: l, ...d }) {
	return /* @__PURE__ */ i(c, {
		container: s,
		children: [/* @__PURE__ */ r(u, { className: o }), /* @__PURE__ */ i(a.Content, {
			"data-slot": "dialog-content",
			className: e("bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200 sm:max-w-lg", t),
			...d,
			children: [l, /* @__PURE__ */ i(a.Close, {
				className: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
				children: [/* @__PURE__ */ r(n, {}), /* @__PURE__ */ r("span", {
					className: "sr-only",
					children: "Close"
				})]
			})]
		})]
	});
}
function f({ className: t, ...n }) {
	return /* @__PURE__ */ r("div", {
		"data-slot": "dialog-header",
		className: e("flex flex-col gap-2 text-left", t),
		...n
	});
}
function p({ className: t, ...n }) {
	return /* @__PURE__ */ r("div", {
		"data-slot": "dialog-footer",
		className: e("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", t),
		...n
	});
}
function m({ className: t, ...n }) {
	return /* @__PURE__ */ r(a.Title, {
		"data-slot": "dialog-title",
		className: e("text-lg leading-none font-semibold", t),
		...n
	});
}
function h({ className: t, ...n }) {
	return /* @__PURE__ */ r(a.Description, {
		"data-slot": "dialog-description",
		className: e("text-muted-foreground text-sm", t),
		...n
	});
}
export { o as Dialog, l as DialogClose, d as DialogContent, h as DialogDescription, p as DialogFooter, f as DialogHeader, u as DialogOverlay, c as DialogPortal, m as DialogTitle, s as DialogTrigger };
